<template>
  <vuex-table :fields="fields" table_store="pbx/worksheets/table" class="table--content-middle">
    <template slot="name" slot-scope="{ item }">
      <editable-name
        :id="item.id"
        :value="item.name"
        :is_edit="item.id === edit_id"
        @on-complete="cancel_edit"
      >
        <template slot="default" slot-scope="{ value }">
          <router-link :to="{ name: 'pbx.worksheet.edit', params: { id: item.id } }">
            {{ value }}
          </router-link>
        </template>
      </editable-name>
    </template>

    <template slot="status" slot-scope="{ item }">
      <div class="worksheet-table-status">
        <editable-status :id="item.id" :value="item.status" />
        {{ item.status ? $t('pbx.worksheet.status.active') : $t('pbx.worksheet.status.draft') }}
      </div>
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="start_edit(item.id)">
          {{ $t('shared.component.table.action.rename') }}
        </span>

        <router-link
          tag="span"
          class="dropdown-item-icon dropdown-item-icon--config"
          :to="{ name: 'pbx.worksheet.edit', params: { id: item.id } }"
        >
          {{ $t('shared.component.table.action.change') }}
        </router-link>

        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="remove_item(item)">
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import EditableName from '@pbx/components/worksheets/_fragments/editable/name';
  import EditableStatus from '@pbx/components/worksheets/_fragments/editable/status';
  import { WorksheetModalService } from '@pbx/modals/WorksheetModalService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      EditableName,
      EditableStatus
    },

    data: () => ({
      edit_id: null
    }),

    computed: {
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'),
            sortable: true,
            class: 'w-25'
          },
          {
            key: 'status',
            label: this.$t('shared.component.table.field.status'),
            sortable: true,
            class: 'w-25'
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true
          },
          {
            key: 'updated_at',
            label: this.$t('shared.component.table.field.updated_at'),
            sortable: true
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/worksheets/table', ['getAsyncData']),

      remove_item: function (item) {
        WorksheetModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      },

      start_edit: function (id) {
        this.edit_id = id;
      },

      cancel_edit: function () {
        this.edit_id = null;
      }
    }
  };
</script>

<style lang="scss">
  .zorra-dropdown-menu {
    li {
      a {
        color: #394858;

        &:hover {
          text-decoration: none;
          color: #2196f3;
        }
      }
    }
  }

  .worksheet-table-status {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;

    .z-switch-checkbox {
      margin-right: 20px;
    }
  }
</style>
